import type { UserAccess } from '~/interfaces/UserAccess'
import { useUserStore } from '~/stores/useUserStore'

export const useUserAccess = (): UserAccess => {
  const userStore = useUserStore()
  return { fetchUserAccess: (force = false) => userStore.fetchUserAccess(force) }
}
